import moment from 'moment';
// const today = moment('8:00 am', 'h:mm a')

const blankDayType = (startDate) => {
  const dayString = moment(startDate).format('YYYY-MM-DD') + ' ';

  return {
    itemType: "dayType",
    title: '',
    date: moment(startDate),
    dayTypeId: null,
    dayTypeComment: null,
    myDayTypeComment: null,
  }
};

export default blankDayType;



// WEBPACK FOOTER //
// ./src/Components/Schedule/utils/live-schedules/blankDayType.js